import { useEffect, useState } from "react";
import { AlertTriangle, Download, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const AnswerSheetConfirm = ({ open, onOpenChange, form, version, onDownload, busy }) => {
  const [ack, setAck] = useState(false);
  useEffect(() => { if (open) setAck(false); }, [open]);
  const official = form.kind === "official";
  const link = version.source_url || form.info_url;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} data-testid="answer-sheet-confirm-dialog" className="max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle>Answer sheet only</DialogTitle></DialogHeader>
        <div className="space-y-4 text-sm text-slate-700">
          <p className="flex gap-2 rounded-md border border-amber-300 bg-amber-50 p-3 text-amber-900" data-testid="answer-sheet-confirm-warning">
            <AlertTriangle className="h-5 w-5 shrink-0" />
            {official ? `The official ${form.number} will not be filled. You'll download a text file with your answers. Copy each answer onto the official form, then sign and submit it yourself.`
              : "This is an EVR template, not an official form. You'll download a text file with your answers for your own records."}
          </p>
          {official && link && <a href={link} target="_blank" rel="noreferrer" data-testid="answer-sheet-official-link" className="inline-flex items-center gap-1 font-medium text-navy underline">Open the official {form.number} <ExternalLink className="h-3.5 w-3.5" /></a>}
          <label className="flex items-start gap-3 rounded-md border p-3">
            <Checkbox checked={ack} onCheckedChange={(v) => setAck(!!v)} data-testid="answer-sheet-ack-checkbox" className="mt-0.5" />
            <span>{official ? "I understand the official form has not been filled and I must copy my answers onto it myself." : "I understand this is not an official form and nothing is filed for me."}</span>
          </label>
          <Button onClick={onDownload} disabled={!ack || busy} data-testid="answer-sheet-download-button" className="h-11 w-full bg-navy hover:bg-navy-2">
            <Download className="mr-1.5 h-4 w-4" /> {busy ? "Preparing..." : "Download answer sheet"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
